import {
  RecoverMetricTimeSeriesSchema,
  RecoverMetricTotalsSchema,
} from "@redotech/redo-model/aggregated-metrics/recover-conversation";
import { yyyyMmDdSchema } from "@redotech/redo-model/common/zod-util";
import * as z from "zod";

export const GetRecoverDailyMetricsInputSchema = z.object({
  startDate: yyyyMmDdSchema.describe(
    "Start date for the analytics period (YYYY-MM-DD)",
  ),
  endDate: yyyyMmDdSchema.describe(
    "End date for the analytics period (YYYY-MM-DD)",
  ),
  automationFilter: z
    .object({
      automationId: z.string().describe("Filter to a specific automation"),
      automationStepIds: z
        .array(z.string())
        .optional()
        .describe("Filter to specific steps within the automation"),
    })
    .optional(),
});

export const GetRecoverDailyMetricsOutputSchema = z.object({
  metrics: z
    .array(RecoverMetricTimeSeriesSchema)
    .describe("Time series data for each recover metric"),
  totals: RecoverMetricTotalsSchema.describe(
    "Total values for each metric over the period",
  ),
});

export type GetRecoverDailyMetricsInput = z.infer<
  typeof GetRecoverDailyMetricsInputSchema
>;
export type GetRecoverDailyMetricsOutput = z.infer<
  typeof GetRecoverDailyMetricsOutputSchema
>;

export const getRecoverDailyMetrics = {
  name: "getRecoverDailyMetrics" as const,
  input: GetRecoverDailyMetricsInputSchema,
  output: GetRecoverDailyMetricsOutputSchema,
};
